/**
* @Author 22030124/xieyq
* @Date 2023-11-09 11:11:19
* @Description 人员选择相关请求js
*/
// 引入请求库
import axios from 'axios'
import request from '@/utils/request'
// 提示
import { Message } from 'element-ui'

// 定义请求类
class Request {
  constructor(baseURL, key) {
    this.request = axios.create({
      // 基础url
      baseURL: `${baseURL}/api/system/openApi/userModule`,
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 50000,
      // 请求参数
      params: {
        key
      }
    })

    // 处理错误信息
    const handleError = (res) => {
      Message({
        message: res.message || res.error || res.msg || 'Error',
        type: 'error',
        duration: 2000,
        showClose: true
      })
    }

    // 响应拦截
    this.request.interceptors.response.use(
      (response) => {
        const res = response.data
        if (res.code === 200 || res.code === '200' || Array.isArray(res)) {
          return res
        } else {
          // 处理错误信息
          handleError(res)
          return Promise.reject(res.message || res.error || 'Error')
        }
      },
      (error) => {
        console.log('err' + error)
        if (axios.isCancel(error)) {
          // 主动取消请求
          return Promise.reject(error)
        }
        // 如果错误有响应值
        if (error.response && error.response.data) {
          handleError(error.response.data)
        } else if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message?.includes('timeout')) {
          // 网络超时异常处理
          Message({
            message: '请求超时，请稍后重试',
            type: 'error',
            duration: 2 * 1000
          })
        } else {
          Message({
            message: error.message,
            type: 'error',
            duration: 2000,
            showClose: true
          })
        }
        return Promise.reject(error)
      }
    )
  }

  /**
   * 获取人员列表
   * @param {*} params 请求参数
   * @returns {Promise}
   */
  requestPersonList(params) {
    return this.request({
      url: '/listUser',
      method: 'GET',
      params
    })
  }

  /**
   * 获取常用联系人
   * @param {*} data 请求参数
   * @returns {Promise}
   */
  requestFrequentPerson(data) {
    return this.request({
      url: '/frequent/page',
      method: 'POST',
      data
    })
  }

  requestPerson(params) {
    return request({
      url: `/base/iam/users/page`,
      method: 'GET',
      params
    })
  }

  /**
   * 新增常用联系人
   * @param {String} userId 用户id
   * @param {*} params 请求参数
   * @returns {Promise}
   */
  requestFrequentPersonAdd(userId, params) {
    return this.request({
      url: `/frequent/${userId}/add`,
      method: 'PUT',
      params
    })
  }

  /**
   * 批量新增常用联系人
   * @param {*} data 请求体参数
   * @returns {Promise}
   */
  requestFrequentPersonAddBatch(data) {
    return this.request({
      url: `/frequent/batchAdd`,
      method: 'POST',
      data
    })
  }

  /**
   * 获取部门联系人
   * @param {*} data 请求参数
   * @returns {Promise}
   */
  requestDepartPerson(data) {
    return this.request({
      url: '/depart/page',
      method: 'POST',
      data
    })
  }

  /**
   * 获取收藏联系人
   * @param {*} data 请求参数
   * @returns {Promise}
   */
  requestFavoritePerson(data) {
    return this.request({
      url: '/favorite/page',
      method: 'POST',
      data
    })
  }

  /**
   * 收藏联系人
   * @param {*} userId 用户id
   * @param {*} params 请求参数
   * @returns {Promise}
   */
  requestFavoritePersonAdd(userId, params) {
    return this.request({
      url: `/favorite/${userId}/add`,
      method: 'PUT',
      params
    })
  }

  /**
   * 取消收藏联系人
   * @param {*} userId 用户id
   * @param {*} params 请求参数
   * @returns {Promise}
   */
  requestFavoritePersonCancel(userId, params) {
    return this.request({
      url: `/favorite/${userId}/cancel`,
      method: 'DELETE',
      params
    })
  }
}

export default Request
